// JsFromRoutes CacheKey ade62264d2bba7fdab9e5842f8b61afc
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@corp/services/api'

export default {
  search: /* #__PURE__ */ definePathHelper('post', '/admin/consumer/forced_fraud_reviews/search'),
  destroyForCurrentUser: /* #__PURE__ */ definePathHelper('post', '/admin/consumer/forced_fraud_reviews/destroy_for_current_user'),
  index: /* #__PURE__ */ definePathHelper('get', '/admin/consumer/forced_fraud_reviews'),
  create: /* #__PURE__ */ definePathHelper('post', '/admin/consumer/forced_fraud_reviews'),
  destroy: /* #__PURE__ */ definePathHelper('delete', '/admin/consumer/forced_fraud_reviews/:id'),
}
